module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main-settings/store-banks/store-banks.component.css
// module id = ./src/app/main-settings/store-banks/store-banks.component.css
// module chunks = main